"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_map_1 = require("@nexys/react-map");
var View = __importStar(require("../../view"));
var ViewUI = function (_a) {
    var data = _a.data, _b = _a.notFoundMessage, notFoundMessage = _b === void 0 ? 'Address is not set.' : _b, showMap = _a.showMap;
    if (!data || !data.isSet) {
        return react_1["default"].createElement(core_1.Typography, null, notFoundMessage);
    }
    var linearized = [data.street, data.zip, data.city, data.country.name].join(' ');
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(View.Wrapper, { label: "Address" },
            react_1["default"].createElement(core_1.Typography, null, data.street),
            react_1["default"].createElement(core_1.Typography, null,
                data.city,
                " ",
                data.zip),
            react_1["default"].createElement(core_1.Typography, null, data.country.name)),
        showMap && (react_1["default"].createElement(react_map_1.Map, { address: linearized, width: "100%", style: { marginTop: '1rem' } }))));
};
exports["default"] = ViewUI;
